import React, { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation, useParams } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import env from "../config";
import { toast } from "react-toastify";

const TopbarLayout = ({ children, routes = [] }) => {
  let [sidebarActive, seSidebarActive] = useState(true);
  let [mobileMenu, setMobileMenu] = useState(false);
  const [showGuide, setShowGuide] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [menuPos, setMenuPos] = useState({ top: 0, left: 0 });
  const toggleRefs = useRef({});
  const location = useLocation(); // Hook to get the current route
  const {companyId}=useParams()

  const toggleDropdown = (index) => {
    if (openDropdown === index) { setOpenDropdown(null); return; }
    const btn = toggleRefs.current[index];
    if (btn) {
      const r = btn.getBoundingClientRect();
      setMenuPos({ top: r.bottom + 4, left: r.left });
    }
    setOpenDropdown(index);
  };

  useEffect(() => {
    const onDocClick = (e) => {
      if (!e.target.closest("[data-tb-dropdown]")) setOpenDropdown(null);
    };
    const onScroll = () => setOpenDropdown(null);
    document.addEventListener("mousedown", onDocClick);
    window.addEventListener("scroll", onScroll, true);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      window.removeEventListener("scroll", onScroll, true);
    };
  }, []);

  useEffect(() => { setOpenDropdown(null); }, [location.pathname]);

  const loginCssLink = `@import url("https://script.crmgenix.com/webhook/login_page_css/${companyId}");`;
  const returnCssLink = `@import url("https://script.crmgenix.com/webhook/retrun_css/${companyId}");`;
  const jsScriptLink = `<script src="${env.API_URL}/webhook/script/{{user.companyId}}/{{user.role}}/{{user.type}}"></script>`;

  const copySingle = (text, label) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    toast.success(`${label} copied`);
  };

  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px"; // Collapse submenu
        }
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
        }
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
            }
          }
        });
      });
    };

    // Open the submenu that contains the active route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  const pathSegments = location.pathname.split("/").filter(Boolean);
  const baseSegment = (path) =>
    (path || "").replace("/*", "").replace(/^\/+/, "").split("/")[0];
  const isRouteActive = (route) => {
    const seg = baseSegment(route?.route);
    if (!seg) return false;
    if (pathSegments.includes(seg)) return true;
    if (route?.key && pathSegments.includes(route.key)) return true;
    return false;
  };
  const isSubRouteActive = (subRoute) => {
    const seg = baseSegment(subRoute?.route);
    if (!seg) return false;
    return pathSegments.includes(seg);
  };

  return (
    <section className={"overlay"}>
      {/* sidebar */}

      <main>
        <div className="navbar-header topbar-shell">
          <style>{`
            .topbar-shell {
              border-bottom: 1px solid #eef1f6;
              background: #fff;
            }
            .topbar-scroll-wrap {
              position: relative;
              min-width: 0;
              flex: 1 1 auto;
            }
            .topbar-nav-scroll {
              min-width: 0;
              overflow-x: auto;
              overflow-y: hidden;
              padding: 6px 2px;
              scrollbar-width: none;
              -ms-overflow-style: none;
              transition: scrollbar-color .25s ease;
            }
            .topbar-nav-scroll::-webkit-scrollbar {
              height: 6px;
            }
            .topbar-nav-scroll::-webkit-scrollbar-track {
              background: transparent;
            }
            .topbar-nav-scroll::-webkit-scrollbar-thumb {
              background-color: transparent;
              border-radius: 6px;
              transition: background-color .25s ease;
            }
            .topbar-scroll-wrap:hover .topbar-nav-scroll {
              scrollbar-width: thin;
              scrollbar-color: #cbd5e1 transparent;
            }
            .topbar-scroll-wrap:hover .topbar-nav-scroll::-webkit-scrollbar-thumb {
              background-color: #cbd5e1;
            }
            .topbar-scroll-wrap:hover .topbar-nav-scroll::-webkit-scrollbar-thumb:hover {
              background-color: #94a3b8;
            }
            .topbar-nav {
              display: inline-flex;
              align-items: center;
              gap: 2px;
            }
            .topbar-nav .nav-item {
              position: relative;
              display: flex;
              align-items: center;
            }
            .topbar-nav .nav-link {
              position: relative;
              display: inline-flex;
              align-items: center;
              gap: 7px;
              padding: 8px 14px 8px 16px;
              color: #475569;
              font-size: 13.5px;
              font-weight: 500;
              line-height: 1.2;
              border: 0;
              background: transparent;
              border-radius: 8px;
              white-space: nowrap;
              transition: color .15s ease, background-color .15s ease;
              overflow: hidden;
            }
            .topbar-nav .nav-link::before {
              content: "";
              position: absolute;
              left: 0;
              top: 7px;
              bottom: 7px;
              width: 3px;
              background: transparent;
              border-radius: 0 3px 3px 0;
              transition: background-color .15s ease, top .15s ease, bottom .15s ease;
            }
            .topbar-nav .nav-link:hover {
              color: #1d4ed8;
              background-color: rgba(37, 99, 235, 0.08);
            }
            .topbar-nav .nav-link.active,
            .topbar-nav .nav-link.show {
              color: #1d4ed8;
              font-weight: 600;
              background-color: rgba(37, 99, 235, 0.1);
            }
            .topbar-nav .nav-link.active:hover,
            .topbar-nav .nav-link.show:hover {
              color: #1d4ed8;
              background-color: rgba(37, 99, 235, 0.14);
            }
            .topbar-nav .nav-link.active::before,
            .topbar-nav .nav-link.show::before {
              background-color: #2563eb;
              top: 4px;
              bottom: 4px;
            }
            .topbar-nav .nav-link .nav-icon {
              display: inline-flex;
              align-items: center;
              font-size: 16px;
              color: #94a3b8;
              transition: color .15s ease;
            }
            .topbar-nav .nav-link:hover .nav-icon,
            .topbar-nav .nav-link.active .nav-icon,
            .topbar-nav .nav-link.show .nav-icon {
              color: #2563eb;
            }
            .topbar-nav .dropdown-toggle {
              cursor: pointer;
            }
            .topbar-nav .dropdown-toggle::before {
              content: none;
            }
            .topbar-nav .dropdown-toggle::after {
              display: none;
            }
            .topbar-nav .dropdown-toggle .dt-caret {
              font-size: 15px;
              opacity: .55;
              margin-left: 1px;
              color: currentColor;
              transition: transform .15s ease, opacity .15s ease;
            }
            .topbar-nav .dropdown-toggle:hover .dt-caret,
            .topbar-nav .dropdown.show .dropdown-toggle .dt-caret,
            .topbar-nav .nav-link.active .dt-caret {
              opacity: 1;
            }
            .topbar-nav .dropdown.show .dropdown-toggle .dt-caret {
              transform: rotate(180deg);
            }
            .topbar-nav .dropdown-menu {
              border: 1px solid rgba(15, 23, 42, 0.06);
              border-radius: 12px;
              box-shadow:
                0 20px 40px -16px rgba(15, 23, 42, 0.22),
                0 8px 18px -8px rgba(15, 23, 42, 0.08),
                0 1px 0 rgba(255, 255, 255, 0.6) inset;
              padding: 6px;
              margin-top: 6px;
              min-width: 230px;
              background: #ffffff;
              animation: tb-dd-in .18s cubic-bezier(.2,.7,.2,1);
              transform-origin: top left;
              backdrop-filter: saturate(140%);
            }
            @keyframes tb-dd-in {
              from { opacity: 0; transform: translateY(-6px) scale(.98); }
              to   { opacity: 1; transform: translateY(0)    scale(1); }
            }
            .topbar-nav .dropdown-menu .dd-header {
              display: flex;
              align-items: center;
              gap: 6px;
              padding: 6px 10px 8px;
              margin-bottom: 4px;
              border-bottom: 1px solid #f1f5f9;
              font-size: 10.5px;
              font-weight: 700;
              text-transform: uppercase;
              letter-spacing: 0.08em;
              color: #94a3b8;
            }
            .topbar-nav .dropdown-item {
              position: relative;
              display: flex;
              align-items: center;
              gap: 8px;
              border-radius: 8px;
              padding: 9px 12px 9px 14px;
              font-size: 13px;
              color: #475569;
              font-weight: 500;
              transition: background-color .14s ease, color .14s ease, padding-left .14s ease;
            }
            .topbar-nav .dropdown-item::before {
              content: "";
              position: absolute;
              left: 4px;
              top: 50%;
              transform: translateY(-50%);
              width: 3px;
              height: 0;
              background: #2563eb;
              border-radius: 0 3px 3px 0;
              transition: height .18s ease, opacity .18s ease;
              opacity: 0;
            }
            .topbar-nav .dropdown-item:hover {
              background-color: rgba(37, 99, 235, 0.07);
              color: #1d4ed8;
              padding-left: 18px;
            }
            .topbar-nav .dropdown-item:hover::before {
              height: 16px;
              opacity: .55;
            }
            .topbar-nav .dropdown-item.active {
              background-color: rgba(37, 99, 235, 0.1);
              color: #1d4ed8;
              font-weight: 600;
              padding-left: 18px;
            }
            .topbar-nav .dropdown-item.active::before {
              height: 18px;
              opacity: 1;
            }
            .topbar-nav .dropdown-item .dd-bullet {
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background: #cbd5e1;
              flex-shrink: 0;
              transition: background-color .14s ease, transform .14s ease;
            }
            .topbar-nav .dropdown-item:hover .dd-bullet { background: #60a5fa; }
            .topbar-nav .dropdown-item.active .dd-bullet { background: #2563eb; transform: scale(1.15); }
            .topbar-cta {
              display: inline-flex;
              align-items: center;
              gap: 6px;
              padding: 8px 14px;
              background: linear-gradient(180deg, #2563eb 0%, #1d4ed8 100%);
              color: #fff;
              font-size: 13px;
              font-weight: 600;
              line-height: 1.2;
              border: 0;
              border-radius: 8px;
              box-shadow: inset 0 1px 0 rgba(255,255,255,.18), 0 1px 2px rgba(29,78,216,.35);
              white-space: nowrap;
              transition: transform .12s ease, box-shadow .12s ease, filter .12s ease;
            }
            .topbar-cta:hover {
              filter: brightness(1.04);
              box-shadow: inset 0 1px 0 rgba(255,255,255,.2), 0 4px 12px rgba(29,78,216,.32);
              transform: translateY(-1px);
              color: #fff;
            }
            .topbar-cta:active {
              transform: translateY(0);
              filter: brightness(.98);
            }
            .topbar-cta:focus-visible {
              outline: 2px solid #93c5fd;
              outline-offset: 2px;
            }
            .topbar-cta-icon {
              font-size: 16px;
            }
          `}</style>
          <div className="d-flex align-items-center justify-content-between flex-nowrap gap-3">
            <div className="topbar-scroll-wrap">
              <div className="topbar-nav-scroll">
                <ul
                  className="nav topbar-nav flex-nowrap mb-0"
                  id="pills-tab-six"
                  role="tablist"
                  style={{ whiteSpace: "nowrap" }}
                >
                  {routes.map((route, index) => (
                    <li className={`nav-item dropdown ${openDropdown === index ? "show" : ""}`} key={index} data-tb-dropdown>
                      {route.items && route.items.length > 0 ? (
                        <>
                          <button
                            ref={(el) => (toggleRefs.current[index] = el)}
                            className={`nav-link dropdown-toggle ${
                              isRouteActive(route) ? "active" : ""
                            } ${openDropdown === index ? "show" : ""}`}
                            type="button"
                            data-tb-dropdown
                            aria-expanded={openDropdown === index}
                            onClick={() => toggleDropdown(index)}
                          >
                            {route.icon ? (
                              <span className="nav-icon">{route.icon}</span>
                            ) : null}
                            <span>{route.title}</span>
                            <Icon
                              icon="mdi:chevron-down"
                              className="dt-caret"
                            />
                          </button>
                          {openDropdown === index && (
                            <ul
                              className="dropdown-menu show"
                              data-tb-dropdown
                              style={{ position: "fixed", top: menuPos.top, left: menuPos.left, zIndex: 99999, display: "block" }}
                            >
                              <li className="dd-header">
                                {route.icon ? <span style={{ display: "inline-flex", fontSize: 13 }}>{route.icon}</span> : null}
                                <span>{route.title}</span>
                              </li>
                              {route.items.map((subRoute, subIndex) => (
                                <li key={subIndex}>
                                  <Link
                                    className={`dropdown-item ${
                                      isSubRouteActive(subRoute) ? "active" : ""
                                    }`}
                                    to={`.${subRoute.route.replace("/*", "")}`}
                                    onClick={() => setOpenDropdown(null)}
                                  >
                                    <span className="dd-bullet" />
                                    <span>{subRoute.title}</span>
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          )}
                        </>
                      ) : (
                        <Link
                          to={`.${route.route.replace("/*", "")}`}
                          className={`nav-link ${
                            isRouteActive(route) ? "active" : ""
                          }`}
                        >
                          {route.icon ? (
                            <span className="nav-icon">{route.icon}</span>
                          ) : null}
                          <span>{route.title}</span>
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="flex-shrink-0">
              <button
                type="button"
                className="topbar-cta"
                onClick={() => setShowGuide(true)}
                title="View setup guide"
              >
                <Icon icon="mdi:book-open-variant" className="topbar-cta-icon" />
                <span>Setup custom JS &amp; CSS</span>
              </button>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className="dashboard-main-body">{children}</div>

        {showGuide && (
          <div
            className="modal fade show d-block"
            tabIndex={-1}
            style={{ backgroundColor: "rgba(15, 23, 42, 0.6)", zIndex: 2000 }}
            onClick={(e) => {
              if (e.target === e.currentTarget) setShowGuide(false);
            }}
          >
            <style>{`
              .setup-guide-modal .modal-content {
                border-radius: 16px;
                overflow: hidden;
                box-shadow: 0 24px 50px -12px rgba(15,23,42,.25);
              }
              .setup-guide-modal .modal-header {
                padding: 22px 24px 12px;
              }
              .setup-guide-modal .modal-title {
                font-size: 17px;
                color: #0f172a;
              }
              .setup-guide-modal .modal-body {
                padding: 8px 24px 4px;
              }
              .setup-guide-modal .modal-footer {
                padding: 12px 24px 22px;
              }
              .setup-guide-modal .steps-block {
                background: #f8fafc;
                border: 1px solid #eef1f6;
                border-radius: 12px;
                padding: 14px 16px;
                margin-bottom: 18px;
              }
              .setup-guide-modal .step-row {
                display: flex;
                gap: 12px;
                align-items: flex-start;
                padding: 6px 0;
              }
              .setup-guide-modal .step-row + .step-row {
                border-top: 1px dashed #e2e8f0;
                margin-top: 2px;
              }
              .setup-guide-modal .step-row .step-text {
                color: #475569;
                line-height: 1.5;
                padding-top: 4px;
                font-size: 13px;
              }
              .setup-guide-modal .step-row .step-text strong {
                color: #0f172a;
                font-weight: 600;
              }
              .setup-guide-modal .step-pill {
                width: 26px;
                height: 26px;
                border-radius: 50%;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                font-weight: 700;
                font-size: 12px;
                flex-shrink: 0;
                background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
                color: #1d4ed8;
                box-shadow: inset 0 0 0 1px rgba(29,78,216,.15);
                margin-top: 2px;
              }
              .setup-guide-modal .snippet-card {
                border-radius: 12px;
                overflow: hidden;
                border: 1px solid #e5e7eb;
                background: #fff;
              }
              .setup-guide-modal .snippet-card + .snippet-card {
                margin-top: 14px;
              }
              .setup-guide-modal .snippet-head {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 11px 14px;
                font-size: 13px;
                font-weight: 600;
                background: #f8fafc;
                color: #0f172a;
                border-bottom: 1px solid #eef1f6;
              }
              .setup-guide-modal .snippet-head .snippet-label {
                display: inline-flex;
                align-items: center;
                gap: 8px;
              }
              .setup-guide-modal .snippet-head .snippet-dot {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                display: inline-block;
              }
              .setup-guide-modal .snippet-head.css .snippet-dot { background: #2563eb; }
              .setup-guide-modal .snippet-head.js  .snippet-dot { background: #f97316; }
              .setup-guide-modal .snippet-head.css .snippet-icon { color: #2563eb; }
              .setup-guide-modal .snippet-head.js  .snippet-icon { color: #c2410c; }
              .setup-guide-modal .snippet-row {
                display: flex;
                align-items: center;
                gap: 10px;
                padding: 11px 14px;
                border-top: 1px solid #f1f5f9;
                font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
                font-size: 12.5px;
                transition: background-color .12s ease;
              }
              .setup-guide-modal .snippet-row:hover {
                background-color: #fafbfc;
              }
              .setup-guide-modal .snippet-row code {
                flex: 1;
                color: #334155;
                word-break: break-all;
                background: transparent;
                font-size: 12.5px;
              }
              .setup-guide-modal .copy-btn {
                border: 1px solid #e2e8f0;
                background: #fff;
                color: #475569;
                padding: 5px 10px;
                border-radius: 6px;
                font-size: 12px;
                font-weight: 500;
                display: inline-flex;
                align-items: center;
                gap: 4px;
                transition: background-color .15s ease, color .15s ease, border-color .15s ease;
                flex-shrink: 0;
              }
              .setup-guide-modal .copy-btn:hover {
                background: #eff6ff;
                color: #1d4ed8;
                border-color: #bfdbfe;
              }
              .setup-guide-modal .copy-btn-primary {
                background: #2563eb;
                color: #fff;
                border-color: #2563eb;
              }
              .setup-guide-modal .copy-btn-primary:hover {
                background: #1d4ed8;
                color: #fff;
                border-color: #1d4ed8;
              }
            `}</style>
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg setup-guide-modal">
              <div className="modal-content border-0 shadow-lg">
                <div className="modal-header border-0 pb-0">
                  <div>
                    <h5 className="modal-title mb-1 fw-bold d-flex align-items-center gap-2">
                      <Icon
                        icon="mdi:rocket-launch-outline"
                        className="text-primary-600"
                        style={{ fontSize: 22 }}
                      />
                      Setup Guide
                    </h5>
                    <small className="text-secondary-light">
                      Install your custom JS &amp; CSS in GoHighLevel
                    </small>
                  </div>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowGuide(false)}
                  ></button>
                </div>

                <div className="modal-body pt-3">
                  <div className="steps-block">
                    <div className="step-row">
                      <span className="step-pill">1</span>
                      <div className="step-text">
                        Open GoHighLevel &nbsp;→&nbsp;{" "}
                        <strong>Settings</strong> &nbsp;→&nbsp;{" "}
                        <strong>Company</strong> &nbsp;→&nbsp;{" "}
                        <strong>White Label</strong>
                      </div>
                    </div>
                    <div className="step-row">
                      <span className="step-pill">2</span>
                      <div className="step-text">
                        Paste the snippets below into the matching{" "}
                        <strong>Custom CSS</strong> and{" "}
                        <strong>Custom JS</strong> fields
                      </div>
                    </div>
                    <div className="step-row">
                      <span className="step-pill">3</span>
                      <div className="step-text">
                        Click <strong>Save Changes</strong> in each section
                      </div>
                    </div>
                  </div>

                  {/* CSS snippet */}
                  <div className="snippet-card">
                    <div className="snippet-head css">
                      <span className="snippet-label">
                        <span className="snippet-dot"></span>
                        <Icon
                          icon="mdi:language-css3"
                          className="snippet-icon"
                          style={{ fontSize: 18 }}
                        />
                        Custom CSS field
                      </span>
                      <button
                        type="button"
                        className="copy-btn copy-btn-primary"
                        onClick={() =>
                          copySingle(
                            `${loginCssLink}\n${returnCssLink}`,
                            "CSS"
                          )
                        }
                      >
                        <Icon icon="mdi:content-copy" /> Copy both
                      </button>
                    </div>
                    <div className="snippet-row">
                      <code>{loginCssLink}</code>
                      <button
                        type="button"
                        className="copy-btn"
                        onClick={() => copySingle(loginCssLink, "Login CSS")}
                        title="Copy"
                      >
                        <Icon icon="mdi:content-copy" />
                      </button>
                    </div>
                    <div className="snippet-row">
                      <code>{returnCssLink}</code>
                      <button
                        type="button"
                        className="copy-btn"
                        onClick={() => copySingle(returnCssLink, "Return CSS")}
                        title="Copy"
                      >
                        <Icon icon="mdi:content-copy" />
                      </button>
                    </div>
                  </div>

                  {/* JS snippet */}
                  <div className="snippet-card">
                    <div className="snippet-head js">
                      <span className="snippet-label">
                        <span className="snippet-dot"></span>
                        <Icon
                          icon="mdi:language-javascript"
                          className="snippet-icon"
                          style={{ fontSize: 18 }}
                        />
                        Custom JS field
                      </span>
                      <button
                        type="button"
                        className="copy-btn copy-btn-primary"
                        onClick={() => copySingle(jsScriptLink, "JS")}
                      >
                        <Icon icon="mdi:content-copy" /> Copy
                      </button>
                    </div>
                    <div className="snippet-row">
                      <code>{jsScriptLink}</code>
                      <button
                        type="button"
                        className="copy-btn"
                        onClick={() => copySingle(jsScriptLink, "JS")}
                        title="Copy"
                      >
                        <Icon icon="mdi:content-copy" />
                      </button>
                    </div>
                  </div>
                </div>

                <div className="modal-footer border-0 pt-0">
                  <button
                    type="button"
                    className="btn btn-primary px-4"
                    onClick={() => setShowGuide(false)}
                  >
                    Got it
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Footer section */}
        {/* <footer className="d-footer">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <p className="mb-0">© 2024 WowDash. All Rights Reserved.</p>
            </div>
            <div className="col-auto">
              <p className="mb-0">
                Made by <span className="text-primary-600">wowtheme7</span>
              </p>
            </div>
          </div>
        </footer> */}
      </main>
    </section>
  );
};

export default TopbarLayout;
